if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
       constructor() {
        super();
        this.mqlDesktop = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.pointerFine = window.matchMedia('(pointer: fine)');
        this.eventMouseEnterHappened = false;
        this.onTogglePopover = this.togglePopover.bind(this);
        this.onClosePopover = this.closePopover.bind(this);
        this.onKeyup = this.handleKeyup.bind(this);
      }

      connectedCallback() {
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        this.init();
      }

      init() {
        if (!this.popoverInfo) return;

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.onClosePopover);
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.onTogglePopover);
          this.infoButtonDesktop.addEventListener('focusout', this.onClosePopover);

          if (this.mqlTablet.matches && this.pointerFine.matches) {
            this.infoButtonDesktop.addEventListener('mouseenter', this.onTogglePopover);
            this.infoButtonDesktop.addEventListener('mouseleave', this.onClosePopover);
            this.popoverInfo.addEventListener('mouseleave', this.onClosePopover);
          }
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.onTogglePopover);
        }
      }

      getActiveButton() {
        if (this.infoButtonDesktop && this.mqlDesktop.matches) {
          return this.infoButtonDesktop;
        }

        return this.infoButtonMobile || this.infoButtonDesktop;
      }

      togglePopover(event) {
        event.preventDefault();

        if (!this.popoverInfo) return;

        const button = this.getActiveButton();
        if (!button) return;

        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        const shouldToggle = event.type === 'click' || (this.mqlDesktop.matches && !isExpanded);

        if (!shouldToggle) return;

        const nextExpanded = !isExpanded;

        button.setAttribute('aria-expanded', String(nextExpanded));
        button.classList.toggle('quantity-popover__info-button--open', nextExpanded);
        this.popoverInfo.toggleAttribute('hidden', !nextExpanded);

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.classList.toggle(
            'quantity-popover__info-button--icon-only--animation',
            nextExpanded
          );
        }

        if (nextExpanded && event.type !== 'mouseenter') {
          button.focus();
          document.addEventListener('keyup', this.onKeyup);
        } else {
          document.removeEventListener('keyup', this.onKeyup);
        }
      }

      closePopover(event) {
        if (event) event.preventDefault();

        if (!this.popoverInfo) return;

        const button = this.getActiveButton();
        if (!button) return;

        const relatedTarget = event ? event.relatedTarget : null;
        const isButtonChild = relatedTarget && button.contains(relatedTarget);
        const isPopoverChild = relatedTarget && this.popoverInfo.contains(relatedTarget);

        if (!isButtonChild && !isPopoverChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');

          if (this.infoButtonDesktop) {
            this.infoButtonDesktop.classList.remove('quantity-popover__info-button--icon-only--animation');
          }

          document.removeEventListener('keyup', this.onKeyup);
        }

        this.eventMouseEnterHappened = false;
      }

       handleKeyup(event) {
        if (event.key === 'Escape') {
          this.closePopover(event);
          document.removeEventListener('keyup', this.onKeyup);
        }
      }

      disconnectedCallback() {
        if (this.closeButton) {
          this.closeButton.removeEventListener('click', this.onClosePopover);
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.removeEventListener('click', this.onTogglePopover);
          this.infoButtonDesktop.removeEventListener('focusout', this.onClosePopover);
          this.infoButtonDesktop.removeEventListener('mouseenter', this.onTogglePopover);
          this.infoButtonDesktop.removeEventListener('mouseleave', this.onClosePopover);
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.removeEventListener('click', this.onTogglePopover);
        }

        if (this.popoverInfo) {
          this.popoverInfo.removeEventListener('mouseleave', this.onClosePopover);
        }

        document.removeEventListener('keyup', this.onKeyup);
      }
    }
  );
}